// logic
import { Hall, HallType } from '@weblite/ts-action/hall'
// Common
import { ListItemCriticalTextButton } from '$common/buttons/list-item-critical-text-button'
// Localization
import { t } from '$i18n'
import { showDeleteHallModal } from '$comp/modals/confirmation-dialog'

interface Props {
  hall: Hall
  hallType: HallType
}

export function HallSettingsCriticalActions({ hall, hallType }: Props) {
  return (
    <ListItemCriticalTextButton
      text={
        hallType === 'GROUP'
          ? t('profile.hall.criticalActions.deleteGroup')
          : t('profile.hall.criticalActions.deleteChannel')
      }
      onClick={() => showDeleteHallModal(hall.roomId)}
    />
  )
}
